/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: ShippersModule
 * Purpose		: Module for Shippers.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }       from '@angular/core';
import { CommonModule }   from '@angular/common';
import { FormsModule }    from '@angular/forms';
import { SharedModule } from '../shared/Shared.module';

import { ShippersService } from './Shippers.service';
import { ShippersListComponent } from './ShippersList.component';
import { ShippersSearchComponent } from './ShippersSearch.component';
import { ShippersAddComponent } from './ShippersAdd.component';
import { ShippersEditComponent } from './ShippersEdit.component';
import { ShippersDetailsComponent } from './ShippersDetails.component';

import { ShippersRoutingModule } from './Shippers-routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
	SharedModule,
    ShippersRoutingModule
  ],
  declarations: [
    ShippersListComponent,
	ShippersSearchComponent,
    ShippersEditComponent,
    ShippersAddComponent,
	ShippersDetailsComponent
  ],
  providers: [
    ShippersService
  ]
})

export class ShippersModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Shippers/Shippers.module.ts